"use strict";

import _defineProperty from "/app/node_modules/@babel/runtime/helpers/esm/defineProperty.js";
import _slicedToArray from "/app/node_modules/@babel/runtime/helpers/esm/slicedToArray.js";
import classNames from "classnames";
import React, { useEffect, useRef, useState } from "react";
import { randomString } from "../../../utils";
import Tooltip, { TooltipPosition } from "../Tooltip/Tooltip";
import { Label } from "../Label";
import { darkTheme, lightTheme } from "../../../tokens/tokens-css";
import * as styles from "./Toggle-css";
export function Toggle(_ref) {
  var _classNames;
  var value = _ref.value,
    onChange = _ref.onChange,
    label = _ref.label,
    labelHidden = _ref.labelHidden,
    disabled = _ref.disabled,
    getDisabledMessage = _ref.getDisabledMessage,
    theme = _ref.theme,
    className = _ref.className;
  var _useState = useState(""),
    _useState2 = _slicedToArray(_useState, 2),
    disabledMessage = _useState2[0],
    setDisabledMessage = _useState2[1];
  var toggleId = useRef("toggle-".concat(randomString()));
  var labelId = useRef("toggle-label-".concat(randomString()));
  useEffect(function () {
    if (getDisabledMessage) {
      getDisabledMessage().then(function (result) {
        setDisabledMessage(result);
      });
    }
  }, [getDisabledMessage]);
  var renderToggle = function renderToggle() {
    return /* @__PURE__ */React.createElement("button", {
      className: styles.toggle,
      role: "switch",
      id: toggleId.current,
      "aria-disabled": disabled,
      "aria-checked": value,
      "aria-labelledby": labelId.current,
      onClick: toggleValue,
      disabled: disabled,
      type: "button"
    }, /* @__PURE__ */React.createElement("div", {
      className: classNames(styles.handle, lightTheme)
    }));
  };
  var toggleValue = function toggleValue() {
    onChange == null ? void 0 : onChange(!value);
  };
  return /* @__PURE__ */React.createElement("div", {
    className: classNames(className, styles.container({
      disabled: disabled
    }), (_classNames = {}, _defineProperty(_classNames, darkTheme, theme === "dark"), _defineProperty(_classNames, lightTheme, theme === "light"), _classNames))
  }, /* @__PURE__ */React.createElement(Label, {
    long: true,
    element: "label",
    disabled: disabled,
    htmlFor: toggleId.current,
    className: styles.label({
      hidden: labelHidden
    }),
    id: labelId.current
  }, label), disabled ? /* @__PURE__ */React.createElement(Tooltip, {
    wrapTarget: true,
    content: disabledMessage,
    show: disabledMessage ? void 0 : false,
    position: TooltipPosition.Bottom
  }, renderToggle()) : renderToggle());
}